import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { TranslatePipe } from '@ngx-translate/core';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslatePipe],
})
export class BreadcrumbComponent implements OnDestroy {
  breadcrumbService = inject(BreadcrumbService);

  subscription: Subscription;

  items?: MenuItem[];

  constructor() {
    const breadcrumbService = this.breadcrumbService;
    const changeDetectorRef = inject(ChangeDetectorRef);

    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
      changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
